module.exports = __webpack_public_path__ + "static/img/6.d889087.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mgzgk/6.png
// module id = uKMB
// module chunks = 0